import { lazy } from "react";
import { Navigate, useLocation } from "react-router-dom";

const AlertsOverview_V2 = lazy(() => import("pages/Health/Alerts_V3/AlertsOverview"));
const AlertsDetails_V2 = lazy(() => import("pages/Health/Alerts_V3/AlertsDetails"));
const ResourceHealth_V2 = lazy(() => import("pages/Health/ResourceHealth_V2/ResourceHealth"));
const MetricsDetails_V2 = lazy(() => import("pages/Health/Performance_V2/MetricsDetails_V2"));

const RedirectKeepQuery = ({ to }: { to: string }) => {
  const location = useLocation();
  return <Navigate to={`${to}${location.search}`} replace />;
};

export const health = [
  {
    path: "/monitoring/alerts_details",
    element: <RedirectKeepQuery to="/health/alerts_details" />,
  },
  {
    path: "health",
    element: <Navigate to="alerts_overview" replace />,
  },
  {
    path: "health",
    children: [
      {
        path: "alerts_overview",
        element: <AlertsOverview_V2 />,
      },
      {
        path: "alerts_details",
        element: <AlertsDetails_V2 />,
      },
      {
        path: "resource_health",
        element: <ResourceHealth_V2 />,
      },
      {
        path: "performance_overview",
        element: <MetricsDetails_V2 />,
      },
    ],
  },
];
